import { Trans } from '@lingui/react/macro'
import { CantileverButton } from 'components/CantileverButton'
import { SensorScatterplotTable } from 'features/timeSeries'
import { ScatterplotSidebarView } from 'features/timeSeries/components/ScatterplotSidebar'
import { YScaleControls } from 'features/timeSeries/components/YScaleControls'
import { Plus } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

const TableContainer = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
`

const PhantomRow = styled(CantileverButton)`
  width: 100%;
  justify-content: flex-start;
  gap: 0.25rem;
  font-size: 0.75rem;
  opacity: 0.5;
  padding: 0.5rem 0.5rem;
  min-height: 2.25rem;

  &:hover {
    opacity: 0.8;
  }
`

interface PensTabProps {
  setSidebarView?: React.Dispatch<React.SetStateAction<ScatterplotSidebarView>>
}

export const PensTab: React.FC<PensTabProps> = ({ setSidebarView }) => {
  return (
    <TableContainer>
      <YScaleControls />
      <SensorScatterplotTable />
      {setSidebarView && (
        <PhantomRow
          ghost
          size='small'
          onClick={() => setSidebarView(ScatterplotSidebarView.ADD)}>
          <Plus size={12} />
          <Trans>Add</Trans>
        </PhantomRow>
      )}
    </TableContainer>
  )
}
